import { render, staticRenderFns } from "./GroupRow.vue?vue&type=template&id=f13a437e&"
import script from "./GroupRow.vue?vue&type=script&lang=js&"
export * from "./GroupRow.vue?vue&type=script&lang=js&"
import style0 from "./GroupRow.vue?vue&type=style&index=0&id=f13a437e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports